import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useMemo } from 'react';
import { getTestIds } from '../../utils/TestIds';
import { Button } from '../Button';
import { Page } from '../Page';
import { PageEmptyState } from '../PageEmptyState';
import { PageErrorStateIcon } from './PageErrorStateIcon';
export const GetPageErrorStateTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            PageErrorStateTID: {
                RefreshButton: 'page-error-refresh-btn'
            }
        }
    });
/** Renders page contents that indicate an error occurred, with an optional refresh button. */ export function PageErrorState(props) {
    const { title, onRefresh, skin, message, refreshButtonLabel, error, testId } = props, rest = _object_without_properties(props, [
        "title",
        "onRefresh",
        "skin",
        "message",
        "refreshButtonLabel",
        "error",
        "testId"
    ]);
    const { PageErrorStateTID } = useMemo(()=>GetPageErrorStateTID(testId), [
        testId
    ]);
    useEffect(()=>{
        if (error) {
            // eslint-disable-next-line no-console
            console.error('PageErrorState error', error);
        }
    }, [
        error
    ]);
    return /*#__PURE__*/ _jsx(Page, _object_spread_props(_object_spread({
        header: title,
        skin: skin,
        testId: testId
    }, rest), {
        children: /*#__PURE__*/ _jsx(PageEmptyState, {
            illustration: /*#__PURE__*/ _jsx(PageErrorStateIcon, {}),
            message: message || 'Something went wrong. Refresh the page',
            actions: /*#__PURE__*/ _jsx(Button, {
                // eslint-disable-next-line custom/no-hardcoded-bi-name-in-seagull -- WHY: PageErrorState owns the inherent fixed-semantic "refresh" recovery action; consumers cannot rename it (rule 6a), so the name is hardcoded by design, not a missing pass-through.
                bi: {
                    name: 'refresh'
                },
                onClick: onRefresh,
                testId: PageErrorStateTID.RefreshButton(),
                children: refreshButtonLabel !== null && refreshButtonLabel !== void 0 ? refreshButtonLabel : 'Refresh'
            })
        })
    }));
}
